var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 45,
    viewBox: "0 0 24 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28848 17.7573H12.4531V42.3872",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 42.9597H21.7612",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8807 9.16462C10.9744 9.16462 10.0885 8.89587 9.33495 8.39236C8.58139 7.88885 7.99406 7.17319 7.64724 6.33588C7.30042 5.49858 7.20967 4.57723 7.38648 3.68835C7.56329 2.79947 7.99971 1.98298 8.64056 1.34213C9.28141 0.701282 10.0979 0.264859 10.9868 0.0880498C11.8757 -0.0887595 12.797 0.00198543 13.6343 0.348809C14.4716 0.695633 15.1873 1.28296 15.6908 2.03652C16.1943 2.79007 16.463 3.67602 16.463 4.58231C16.463 5.79761 15.9803 6.96314 15.1209 7.82249C14.2616 8.68184 13.096 9.16462 11.8807 9.16462Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicate);
export default __webpack_public_path__ + "static/media/indicate.cd722cdc989db7250d5d8c08b54667fb.svg";
export { ForwardRef as ReactComponent };